import { useTranslate, useShowContext } from 'react-admin'
import React from 'react'
import { Muted, Property } from '../../../components/ui'
import { CertificateOut } from '../../../types/apiRequests'
import { getInstance } from '../../../utils/getInstance'
import { getKoppelvlak } from '../../../utils/getKoppelvlak'

export interface CertificateMetaData {
  commonName?: string
  instanceId?: string
  samlKoppeling?: string
}

const dash = <Muted>-</Muted>

/** Zaken-only properties (environment, kind, interface); the hostname is shown by the form. */
const ZakenDetails: React.FC = () => {
  const translate = useTranslate()
  const { record } = useShowContext<CertificateOut>()

  const samlType = (record?.metaData as CertificateMetaData | undefined)?.samlKoppeling
  const instance = getInstance(record)
  const koppelvlak = getKoppelvlak(record)

  return (
    <>
      <Property label={translate('resources.certificates.fields.instance')}>
        {instance ? <Muted mono plain>{instance}</Muted> : dash}
      </Property>
      <Property label={translate('resources.certificates.fields.kind')}>
        {/* Without a samlKoppeling the raw i18n key would be shown. */}
        {samlType ? translate(`resources.certificates.fields.${samlType}`) : dash}
      </Property>
      <Property label={translate('resources.certificates.fields.interface')}>
        {koppelvlak || dash}
      </Property>
    </>
  )
}

export default ZakenDetails
